<template>
    <div
        class="modal fade inactivity"
        tabindex="-1"
        :id="modalId"
        role="dialog"
    >
        <div class="modal-dialog centerize" role="document">
            <div class="modal-content text-center">
                <div class="divToCenter">
                    <div
                        class="confirmed-payment d-flex justify-content-center align-items-center"
                        v-bind:style="stepSpanStyle"
                    >
                        <div v-html="logo"></div>
                    </div>
                </div>
                <div class="modal-body">
                    <h4 v-html="header"></h4>
                    <p v-html="message"></p>

                    <ColoredButton @click="() => confirm()">
                        {{ type == 'queue' ? 'OK' : 'Okay' }}
                    </ColoredButton>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BookingAddressMixin from "../mixins/BookingAddressMixin";
import ColoredButton from "./ColoredButton";

export default {
    mixins: [BookingAddressMixin],
    components: {
        ColoredButton
    },
    props: {
        modalId: {
            type: String,
            required: true,
            default() {
                return "paymentModal"
            }
        },
        triggerEventName: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            type : null,
            confirmCallback: null,
            denyCallback: null,
            showModal: false,
            isSuccess : false,
            statusMessage : null,
            statusCode : null,

            headerTemplates : {
                default : {
                    success : 'Success',
                    fail : 'Failed'
                },
                booking : {
                    success : 'Booking successful',
                    fail : 'Booking failed'
                },
                payment : {
                    success : 'Payment confirmation',
                    fail : 'Payment validation failed'
                }
            },
            messageTemplates : {
                default : {
                    success : '',
                    fail : 'An error has occured'
                },
                booking : {
                    success : '',
                    fail : 'The server encountered an error processing the request. Please try again after a few minutes.',
                },
                payment : {
                    success : 'Thank you for your booking. We have received your payment',
                    fail : 'Please check your credit card details and place the order again.'
                }
            }
        };
    },
    computed: {
        logo: function() {
            var success = "<i class='icon-check'></i>";
            var fail = "<i class='icon-cross'></i>";
            return "<strong>" + (this.isSuccess ? success : fail) + "</strong>";
        },
        header: function() {
            var success, fail
            // Header message template
            if(this.headerTemplates[this.type]){
                success = this.headerTemplates[this.type].success
                fail = this.headerTemplates[this.type].fail
                return "<strong>" + (this.isSuccess ? success : fail) + "</strong>";
            }

            return "";
        },
        paymentBodyOfError(){
            var bookingSubmission = this.$store.getters.GET_BOOKING_SUBMISSION        
            return bookingSubmission.paymentBody
        },
        activeAddress: function () {
            return this.$store.getters.GET_BOOKING_STATE.activeAddress;
        },
        message: function() {
            var success, fail;
            var self = this;
            if(this.statusCode != 408) {
                if(this.messageTemplates[this.type]){
                    success = this.messageTemplates[this.type].success
                    fail = this.messageTemplates[this.type].fail
                }
                if(this.paymentBodyOfError){
                    var receiptNumber = this.paymentBodyOfError.TxnResp.ReceiptNumber
                    var paymentReference = this.paymentBodyOfError.referenceNumber
                    fail = "There was an error processing your request.<br> Our customer service team will contact you shortly.<br><br>"
                        + '<table style="width: -webkit-fill-available;"><tbody style="width: auto;">'
                        + '<tr><td width="40%" style="text-align: right;">Receipt number:</td><td style="text-align: left;padding-left: 2rem;"> <b>' + receiptNumber + '</b></td></tr>'
                        + '<tr><td style="text-align: right;">Payment reference:</td><td style="text-align: left;padding-left: 2rem;"> <b>' + paymentReference + '</b></td></tr>'
                        + '</tbody></table>'
                }
                else if(this.statusCode){
                    fail = 'Status Code ' + this.statusCode + " <br><br>" + fail
                }
                else if(this.statusMessage){
                    fail = this.statusMessage + ". <br><br>" + fail
                }

                // If type = queue, set message from setting
                if(this.type == 'queue') {
                    success = this.statusMessage;
                }
            } else {
                this.confirmCallback = async () => {
                    $(window).off('beforeunload');
                    window.onbeforeunload = null;
                    if(self.activeAddress && self.activeAddress.displayName) {
                        self.removeAddressToList(self.activeAddress.displayName.toLowerCase());
                    }
                    await self.$store.dispatch("resetBookingState");
                    setTimeout(() => {
                        self.$router.push({ path: '/booking/home' });
                    }, 500);
                };
                fail = 'We encountered an issue while processing your request.<br> Please check your booking history after a few minutes and try again if needed.<br><br>'
            }
            
            return this.isSuccess ? success : fail;
        },
        stepSpanStyle() {
            var color = this.isSuccess ? "#78BE20" : "#D7010B";
            return {
                border: "1px solid " + color,
                color: "#F7F7F7",
                height: "3rem",
                width: "3rem",
                "border-radius": "50%",
                "background-color": color,
                "font-size": "1.125rem",
                "align-items": "center !important",
                "justify-content": "center !important"
            };
        }
    },
    watch: {
        showModal: function() {
            const hashModalId = "#" + this.modalId;
            if (this.showModal) {
                $(hashModalId).modalbs5({
                    show: true,
                    backdrop: "static",
                    keyboard: false
                });
            } else {
                $(hashModalId).modalbs5("hide");
            }
        }
    },
    methods: {
        async confirm() {
            await this.$store.dispatch('setSubmission', { error: null, statusCode : null });
            await this.$store.dispatch('setPaymentInfo', { error: null, statusCode : null });
            this.showModal = false;
            if (typeof this.confirmCallback == 'function') {
                this.confirmCallback();
            }
        }
    },
    mounted() {
        var self = this; // Have to use self to store the reference
        this.$parent.$on(this.triggerEventName, function(
            type,
            isSuccess,
            statusMessage,
            statusCode,
            confirmCallback = null,
            denyCallback = null
        ) {
            self.type = type
            self.isSuccess= isSuccess
            self.statusMessage = statusMessage
            self.statusCode = statusCode
            self.confirmCallback = confirmCallback
            self.denyCallback = denyCallback
            self.showModal = true
        });
    }
};
</script>

<style scoped>
.centerize {
    margin: 30vh auto;
}

.divToCenter {
    margin: 1rem auto;
}


</style>
